export const environment = {
  production: false,
  API: 'https://apiadministration-dev.binariks.net/',
  AccountingAPI: 'https://apiaccounting-dev.binariks.net/',
  timeTrackingTool: 'https://timedev.binariks.net',
  auth0Config: {
    domain: 'dev-binar001.eu.auth0.com',
    clientId: 'FciEnKUHsz1ZbJKxE6NYRwM5bXyMahVP',
    authorizationParams: {
      redirect_uri: window.location.origin,
      audience: 'https://internal-tool-api',
    },
  },
  enableWorker: true,
};
